const _sm = "0 1px 2px 0 rgb(0 0 0 / 0.05)"
const _DEFAULT = "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)"
const _md = "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"
const _lg = "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
const _xl = "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
const _2xl = "0 25px 50px -12px rgb(0 0 0 / 0.25)"
const _inner = "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)"
const _none = "none"
const _navbar = "-4px 2px 4px rgba(0, 0, 0, 0.03)"
const _dropdown = "0px 0px 6px rgba(0, 0, 0, 0.12)"
const _brandItem = "0px 0px 10px rgba(0, 0, 0, 0.08)"
const _pagination = "0px 0px 4px rgba(83, 127, 96, 0.12)"
const _card = "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
const _btn = "0px 1px 6px rgba(0, 0, 0, 0.12)"
const _subscribe = "0px 4px 8px rgba(0, 0, 0, 0.12)"
const config = { "sm": _sm, "DEFAULT": _DEFAULT, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl, "inner": _inner, "none": _none, "navbar": _navbar, "dropdown": _dropdown, "brandItem": _brandItem, "pagination": _pagination, "card": _card, "btn": _btn, "subscribe": _subscribe, "navbar-mobile": "-4px 2px 4px rgba(0, 0, 0, 0.06)",  }
export { config as default, _sm, _DEFAULT, _md, _lg, _xl, _2xl, _inner, _none, _navbar, _dropdown, _brandItem, _pagination, _card, _btn, _subscribe }